export const ENABLE_CHECKOUT_EXPRESS_PAYPAL_FF =
    'checkout_enable_express_paypal';

export const POST_CHECKOUT_MANDATORY_QUESTIONS_ORGANIZATIONS_EXCLUSIONS_FF =
    'post-checkout-mandatory-questions-organizations-exclusions';
